module.exports = __webpack_public_path__ + "img/lightning2.4663b2dc.svg";